import { useEffect, useState } from "react";
import Swatch from "./Swatch";
import ColorSlider from "./ColorSlider";
import SpecialColorSlider from "./SpecialColorSlider";
import $ from "jquery";
// import inStockImg from "./media/instock.webp";

export default function ProductLoop({ products, rows }) {
  let classes =
    rows == 4 ? "col-lg-3 col-md-3 col-sm-6" : "col-lg-4 col-md-4 col-sm-6";
  const activeProduct = products.length > 0 ? products[0] : null;
  const [product, setActiveProduct] = useState(activeProduct);
  useEffect(() => {
    setActiveProduct(products.length > 0 ? products[0] : null);
  }, [products]);

  const siteInfo = window.wpProductFilter.siteInfo;
  const site_code = siteInfo.site_code;
  const getcouponbtn = siteInfo.getcouponbtn;
  const getcouponreplace = siteInfo.getcouponreplace;
  const getcouponreplacetext = siteInfo.getcouponreplacetext;
  const getcouponreplaceurl = siteInfo.getcouponreplaceurl;
  const show_financing = siteInfo.show_financing;
  const getfinancereplace = siteInfo.getfinancereplace;
  const getcoupon_link = siteInfo.getcoupon_link;
  const showprice = siteInfo.plpshowprice;
  const hidepriceinstockplpforbrands = siteInfo.hidepriceinstockplpforbrands;
  const hidepriceinstockplp = siteInfo.hidepriceinstockplp;
  const showpricestrik = siteInfo.showpricestrik;
  const showretailandspecialprice = siteInfo.showretailandspecialprice;
  const plpestimatebutton = siteInfo.plpestimatebutton;
  const plpestimatebuttonlink = siteInfo.plpestimatebuttonlink;
  const arearugshowsku = siteInfo.arearugshowsku;
  const hideinstockcoupon = siteInfo.hideinstockcoupon;
  const plprequestquotebtn = siteInfo.plprequestquotebtn;
  const requestquotelink = siteInfo.requestquotelink;
  const plpshowcustomfield = siteInfo.plpshowcustomfield;
  const plpinstockshowcustomfield = siteInfo.plpinstockshowcustomfield;
  const plpcustomfield = siteInfo.plpcustomfield;
  const showpricenormalplp = siteInfo.showpricenormalplp;
  const normalpricecat = siteInfo.normalpricecat;
  const hidepricenormalplpforbrands = siteInfo.hidepricenormalplpforbrands;
  const hidepricenormalplp = siteInfo.hidepricenormalplp;
  const showcustomlabelplp = siteInfo.showcustomlabelplp;
  const plpPageLayout = siteInfo.plpPageLayout;
  const sale_for_only_brand = siteInfo.sale_for_only_brand;
  const sale_brand_list = siteInfo.sale_brand_list;
  const sale_brand_list_arr = Array.isArray(sale_brand_list)
    ? sale_brand_list.map((str) => str.toLowerCase())
    : [];

  const getfinancereplaceurl =
    getfinancereplace === "1"
      ? siteInfo.getfinancereplaceurl
      : "/flooring-financing/";
  const getfinancetext =
    getfinancereplace === "1" ? siteInfo.getfinancetext : "Get Financing";
  const wpProductCategory = window.wpProductCategory;
  const plpFacets = wpProductCategory.plpFacets || [];
  const cat =
    product.z_prod_type === "rugs" ? "area_rugs" : product.z_prod_type;
  const rewrite_slug = wpProductCategory.rewrite_slug[cat]
    ? wpProductCategory.rewrite_slug[cat]
    : "";
  let url_slug = product.url_key;
  if (rewrite_slug !== "" && rewrite_slug !== undefined) {
    const segments = url_slug.split("/");
    url_slug = "/" + rewrite_slug + "/" + segments[segments.length - 1];
  }
  url_slug += url_slug.endsWith("/") ? "" : "/";
  if (product.in_stock == 1) {
    classes = classes + " product_in_stock";
  }
  const current_user_id = siteInfo.current_user_id;
  const showpdpsamplebtn = siteInfo.showpdpsamplebtn;
  const showsamplelabel = siteInfo.showsamplelabel;
  const isworkbook = siteInfo.isworkbook;
  const fav_skus = wpProductCategory.fav_skus ? wpProductCategory.fav_skus : [];
  let link_action = "add_Fav";
  let icon_class = "fa fa-heart-o";
  let hasNew = false;
  let hasBestseller = false;
  let hasNewBestseller = false;
  if (
    product.in_stock == 0 &&
    plpFacets.includes("custom") &&
    showcustomlabelplp == 1 &&
    product?.custom
  ) {
    const customTags =
      product.custom
        ?.toLowerCase()
        .split(",")
        .map((t) => t.trim())
        .filter(Boolean) || [];

    hasNew = customTags.includes("new");
    hasBestseller = customTags.includes("bestseller");
    hasNewBestseller = hasNew && hasBestseller;
  }
  if (fav_skus.includes(product.sku)) {
    link_action = "rem_fav";
    icon_class = "fa fa-heart";
  }
  useEffect(() => {
    if (showpdpsamplebtn == 1) {
      $("a.sample-btn").on("click", function () {
        $("#sample_minicart").remove();
        var sample_src = $(this).data("frame");
        $(document)
          .find(".sampleProduct_popUp .popUp-content")
          .html(
            '<iframe id="sample_minicart" src="' +
              sample_src +
              '" onload="sendOrigin(this)" style="width: 1200px; height: 600px;"></iframe>',
          );
        function sendOrigin(iframe) {
          iframe.contentWindow.postMessage(
            { type: "parent-origin", origin: window.location.origin },
            "https://sample-products.com/",
          );
        }
        $(
          ".minicart .uabb-offcanvas.uabb-custom-offcanvas.uabb-offcanvas-type-noraml",
        ).addClass("uabb-off-canvas-show");
        $(
          ".minicart .uabb-offcanvas.uabb-custom-offcanvas.uabb-offcanvas-type-noraml",
        ).css("right", 0);
      });
      $(".minicart .uabb-offcanvas-close").on("click", function () {
        $(
          ".minicart .uabb-offcanvas.uabb-custom-offcanvas.uabb-offcanvas-type-noraml",
        ).css("right", "-400px");
      });
    }
  });
  return (
    <div className={`product-item ${classes} product-${product.z_prod_type}`}>
      <div className="fl-post-grid-post">
        <div className="fl-post-grid-image">
          <div className="fl-image-strip-wrap">
            {showsamplelabel == 1 &&
              product.hasOwnProperty("sample_sku") &&
              product.sample_sku.trim() != "" && (
                <span class="orderSampleStrip">Sample Available</span>
              )}

            <Swatch
              swatch={product.swatch}
              pdpUrl={`${window.location.origin}${url_slug}`}
              height={222}
              width={222}
              title={product.color}
            />
            {product.in_stock == 1 && (
              <img
                src="/wp-content/plugins/mm-product-listing/build/media/instock.webp"
                className="instockImgPlp entered"
                alt="In Stock"
              />
            )}
            {hasNewBestseller ? (
              <img
                src="https://mobilemarketing-res.cloudinary.com/image/upload/v1770871658/new-bestseller-badge.webp"
                className="instockImgPlp"
                alt="NEW + BESTSELLER"
              />
            ) : hasNew ? (
              <img
                src="https://mobilemarketing-res.cloudinary.com/image/upload/v1770871658/new-stock-badge.webp"
                className="instockImgPlp"
                alt="NEW"
              />
            ) : hasBestseller ? (
              <img
                src="https://mobilemarketing-res.cloudinary.com/image/upload/v1770871659/best-seller-badge.webp"
                className="instockImgPlp"
                alt="BESTSELLER"
              />
            ) : null}
            {isworkbook == 1 &&
              current_user_id !== undefined &&
              current_user_id !== "" && (
                <div className="favProdPLP">
                  <a
                    className={`favProdPdp ${link_action}`}
                    data-user={current_user_id}
                    data-id={product.sku}>
                    <i class={icon_class} aria-hidden="true"></i>
                  </a>
                </div>
              )}
          </div>
        </div>
        <div className="fl-post-grid-text product-grid btn-grey">
          <h4>
            <span>
              {arearugshowsku == "1" && product.z_prod_type === "rugs"
                ? product.sku
                : product.collection_facet}
            </span>
            <span>{product.brand}</span>
            {plpPageLayout !== "normal" && <span>{product.color}</span>}
          </h4>
          <div className="product-variations1">
            <h5>{`${products?.length} COLORS AVAILABLE`}</h5>
            <div className="product-color-variationPlp plp_slide_wrap">
              {plpPageLayout !== "normal" ? (
                <SpecialColorSlider
                  products={products}
                  page={"plp"}
                  setActiveProduct={setActiveProduct}
                  activeSku={product.sku}
                />
              ) : (
                <ColorSlider products={products} page={"plp"} />
              )}
            </div>
          </div>
          {plpshowcustomfield === "1" &&
            plpcustomfield !== "" &&
            plpcustomfield !== undefined &&
            (plpinstockshowcustomfield == 0 ||
              (plpinstockshowcustomfield == 1 && product.in_stock == 1)) && (
              <h5 className="custom_field_info">
                <span class="custom_field_title">
                  {product[plpcustomfield] ? product[plpcustomfield] : ""}
                </span>
              </h5>
            )}
          {product.in_stock == 1 &&
            product.z_prod_type != "carpet" &&
            showprice == 1 &&
            product.price != 0 &&
            showretailandspecialprice == 1 && (
              <div class="price loop-price">
                {product.msrp_unit_price ? (
                  <p>
                    Retail Price: ${Number(product.msrp_unit_price).toFixed(2)}/
                    {product.price_unit} installed
                  </p>
                ) : (
                  ""
                )}
                <span>
                  <strong>
                    Special Price: ${Number(product.price).toFixed(2)}/
                    {product.price_unit} installed
                  </strong>
                </span>
              </div>
            )}
          {product.in_stock == 1 &&
            showprice == 1 &&
            product.price != 0 &&
            (showretailandspecialprice != 1 ||
              product.z_prod_type == "carpet") &&
            (hidepriceinstockplp == 0 ||
              (hidepriceinstockplp == 1 &&
                !hidepriceinstockplpforbrands.includes(
                  product.brand_facet.toLowerCase(),
                ))) && (
              <div className="price">
                <strong>
                  {showpricestrik == 1 && product.msrp_unit_price ? (
                    <span class="msrp-price">
                      ${Number(product.msrp_unit_price).toFixed(2)}
                    </span>
                  ) : (
                    ""
                  )}
                  <span class="sale-price">
                    ${Number(product.price).toFixed(2)}
                  </span>
                </strong>
                {cat !== "area_rugs" && `/${product.price_unit}`}
              </div>
            )}
          {product.in_stock == 0 &&
            showpricenormalplp == 1 &&
            normalpricecat.includes(cat.toLowerCase()) &&
            product.price != 0 &&
            (hidepricenormalplp == 0 ||
              (hidepricenormalplp == 1 &&
                !hidepricenormalplpforbrands.includes(
                  product.brand_facet.toLowerCase(),
                ))) && (
              <div className="price">
                <strong>
                  {showpricestrik == 1 && product.msrp_unit_price ? (
                    <span class="msrp-price">
                      ${Number(product.msrp_unit_price).toFixed(2)}
                    </span>
                  ) : (
                    ""
                  )}
                  <span class="sale-price">
                    ${Number(product.price).toFixed(2)}
                  </span>
                </strong>
                {cat !== "area_rugs" && `/${product.price_unit}`}
              </div>
            )}

          {plprequestquotebtn === "1" &&
          requestquotelink !== "" &&
          requestquotelink !== undefined ? (
            <a
              href={requestquotelink + "?product_id=" + product.sku}
              className="fl-button quote-btn">
              <span className="fl-button-text">REQUEST A QUOTE</span>
            </a>
          ) : (
            ""
          )}
          <a
            href={`${window.location.origin}${url_slug}`}
            className="fl-button plp_box_btn">
            View Product
          </a>
          {getcouponbtn == 1 &&
          getcoupon_link != "" &&
          (product.in_stock == 0 ||
            (product.in_stock == 1 && hideinstockcoupon != 1)) &&
          (sale_for_only_brand == 0 ||
            sale_brand_list_arr.includes(product.brand_facet.toLowerCase())) ? (
            <a href={getcoupon_link} className="link getcouponbtnlink">
              <span className="fl-button-text">GET COUPON</span>
            </a>
          ) : (
            ""
          )}
          {product.in_stock === 1 && plpestimatebutton === "1" ? (
            <a
              href={`${plpestimatebuttonlink}?ChoiceColor=${product.color_facet}&amp;Choicesku=${product.sku}&amp;Choicecollection=${product.collection_facet}&amp;Flooringtype=${product.z_prod_type}`}
              target="_self"
              className="link plpestimatelink"
              role="button">
              <span class="fl-button-text">REQUEST AN ESTIMATE</span>
            </a>
          ) : (
            ""
          )}
          {getcouponreplace === "1" &&
          getcouponreplaceurl !== "" &&
          getcouponreplacetext !== "" ? (
            <a
              href={getcouponreplaceurl}
              className="linkcustompdpbtnlink  d-block">
              <span className="fl-button-text">{getcouponreplacetext}</span>
            </a>
          ) : (
            ""
          )}
          {show_financing === "1" ? (
            <a href={getfinancereplaceurl} className="link d-block">
              <span class="fl-button-text">{getfinancetext}</span>
            </a>
          ) : (
            ""
          )}
          {showpdpsamplebtn == 1 &&
            product.hasOwnProperty("sample_sku") &&
            product.sample_sku.trim() != "" && (
              <a
                href="javascript:void(0)"
                data-frame={`https://sample-products.com/sampleorder/cart/add/product/${product.sample_sku}?store=${site_code}`}
                className="link d-block sample-btn">
                <span class="fl-button-text">ORDER SAMPLE</span>
              </a>
            )}
        </div>
      </div>
    </div>
  );
}
